import React, { useState, useRef, useEffect } from "react";
import validations from "../../Utils/validations";

function ActiveOTP(props) {
  const [pins, setPins] = useState(["", "", "", "", "", ""]);
  const pinRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

  const digitsRegExp = validations.allValidations.digits;

  useEffect(() => {
    pinRefs[0].current.focus();
  }, []);

  const handleChange = (index, e) => {
    const value = e.target.value;

    if (digitsRegExp.test(value)) {
      const newPins = [...pins];
      newPins[index] = value;
      setPins(newPins);

      if (index < 5 && value) {
        pinRefs[index + 1].current.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      const newPins = [...pins];
      newPins[index] = "";
      setPins(newPins);

      if (index > 0) {
        pinRefs[index - 1].current.focus();
      }
    }
  };

  useEffect(() => {
    props.func(pins.join(""));
  }, [pins]);

  return (
    <div>
      <div className="d-flex mt-3">
        {pins.map((pin, index) => (
          <input
            key={index}
            type="tel"
            autoComplete="off"
            className="form-control me-3 otp-input-field "
            maxLength={1}
            ref={pinRefs[index]}
            value={pin}
            onChange={(e) => handleChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
          />
        ))}
      </div>
    </div>
  );
}

export default ActiveOTP;
